/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "zones-management",
	data() {
		return {
			zones: [],
			zonesHeadings: [
				{
					text: "#",
					field: "zoneId"
				},
				{
					text: "Shipping Zone",
					field: "description"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			zoneAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditZoneModal",
				heading: "Add Zone",
				zone:{
					zoneId: null,
					zone: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isActive: true
				}
			},
			newAddOrUpdateConcluded: false,
			zoneMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveZoneModal",
				heading: "Mark Zone As Active/Inactive",
				isActive: null,
				zoneId: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getZones() {
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			let fieldsToFilterBy = [
				{
					value: this.filter.customerSearchQuery,
					key: "description"
				}
			];
			let activeOnly = castingUtility.toBoolean(this.filter.activeOrInactiveItems);
			systemService.getZones(fieldsToFilterBy, request, this.newAddOrUpdateConcluded, activeOnly).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.zones = successResponse.data.result;
						for(let i = 0; i < this.zones.length; i++){
							this.zones[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnEditZone"
								},
								{
									name: this.zones[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnMarkAsActiveInactiveZone"
								}
							];
						}
						this.zones = dataTableHelper.castFieldValues(this.zones);
						this.filterStateChanged = false;
						this.newAddOrUpdateConcluded = false;
						permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getZones();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onAddZoneClick(){
			this.zoneAddEditFormModal.heading = "Add Zone";
			this.clearZoneModel();
			this.zoneAddEditFormModal.showModal = true;
		},
		onZoneActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.zoneAddEditFormModal.showModal = true;
					this.zoneAddEditFormModal.heading = "Edit Zone";
					this.zoneAddEditFormModal.zone.zoneId = actionAndData.data.zoneId;
					this.zoneAddEditFormModal.zone.zone.value = actionAndData.data.description;
					this.zoneAddEditFormModal.zone.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.zoneMarkAsActiveInactiveModal.showModal = true;
					this.zoneMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.zoneMarkAsActiveInactiveModal.heading = "Mark Zone As " + (this.zoneMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.description;
					this.zoneMarkAsActiveInactiveModal.zoneId = actionAndData.data.zoneId;
					break;
			}
		},
		onMarkZoneActiveInactiveSelected(isActive){
			this.zoneMarkAsActiveInactiveModal.isActive = isActive;
			console.log("zoneMarkAsActiveInactiveModal.isActive", this.zoneMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.zoneMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				zoneId: this.zoneMarkAsActiveInactiveModal.zoneId,
				isActive: markAsActive
			};
			systemService.markZoneAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.newAddOrUpdateConcluded = true;
						this.filter = {
							customerSearchQuery: null,
							activeOrInactiveItems: castingUtility.booleanToNumber(markAsActive)
						};
						let key = localStorageCacheHelper.localStorageKey.zonesKey;
						if(markAsActive){
							key = localStorageCacheHelper.localStorageKey.zonesInactiveKey
						}
						localStorageCacheHelper.removeItemFromCache("zoneId", this.zoneMarkAsActiveInactiveModal.zoneId, key);
						this.zoneMarkAsActiveInactiveModal.showModal = false;
						this.zoneMarkAsActiveInactiveModal.isActive = true;
						this.zoneMarkAsActiveInactiveModal.zoneId = null;
						this.getZones();
					}
					this.zoneMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.zoneMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditZoneModalCloseClick(){
			this.zoneAddEditFormModal.showModal = false;
			this.clearZoneModel();
		},
		onAddOrEditZoneSaveClick(){
			this.zoneAddEditFormModal.isSaving = true;
			let request = {
				zoneId: this.zoneAddEditFormModal.zone.zoneId,
				description: this.zoneAddEditFormModal.zone.zone.value,
				isActive: this.zoneAddEditFormModal.zone.isActive
			};
			systemService.addOrUpdateZone(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.zoneValidationResponse.valuesAreValid){
							this.newAddOrUpdateConcluded = true;
							this.filter = {
								customerSearchQuery: null,
								activeOrInactiveItems: castingUtility.booleanToNumber(this.zoneAddEditFormModal.zone.isActive)
							};
							this.getZones();
							this.zoneAddEditFormModal.showModal = false;
							this.clearZoneModel();
						}
						else{
							this.zoneAddEditFormModal.zone.zone.hasError = successResponse.data.zoneValidationResponse.descriptionValidationResponse.hasError;
							this.zoneAddEditFormModal.zone.zone.errorMessage = successResponse.data.zoneValidationResponse.descriptionValidationResponse.message;
						}
					}
					this.zoneAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.zoneAddEditFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearZoneModel(){
			this.zoneAddEditFormModal.zone = {
				zoneId: null,
				zone: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: true
			};
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Shipping Zones Management");
			var breadcrumbs = [];
			var breadcrumbSystem = {
				url: null,
				displayText: "System"
			};
			var reasonsForDeliveryFailureManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Shipping Zones Management"
			};
			breadcrumbs.push(breadcrumbSystem);
			breadcrumbs.push(reasonsForDeliveryFailureManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getZones();
	}
};